<!-- target element to scroll to the messages -->
<div [ishScroll]="scrollToMessage$ | async" [scrollSpacing]="scrollSpacing"></div>
@if (hasGeneralBasketError$ | async) {
<div class="alert alert-danger" data-testing-id="general-validation-message">
  {{ 'basket.validation.general.error' | translate }}
</div>
}
<!-- error messages -->
@for (message of errorMessages$ | async; track message) {
<div class="alert alert-danger" role="alert" data-testing-id="validation-error-message">
  {{ message }}
</div>
}

<!-- info messages -->
@for (message of infoMessages$ | async; track message) {
<div class="alert alert-info" role="alert" data-testing-id="validation-info-message">
  {{ message }}
</div>
}

<!-- undeliverable items -->
@if (undeliverableItems$ | async; as undeliverableItems) { @if (undeliverableItems.length) {
<div class="alert alert-box" role="alert" data-testing-id="undeliverable-items-message">
  <div class="alert-box-header">
    <p>
      {{ 'restricted-items.error.message1' | translate }}<br />
      {{ 'shipping.restriction.shippingMethod' | translate }} {{ 'shipping.restriction.region' | translate }}
    </p>
    {{ 'restricted-items.error.message2' | translate }}
  </div>
  <div class="alert-box-body">
    <ish-basket-validation-items [lineItems]="undeliverableItems" (deleteItem)="deleteItem($event)" />
  </div>
</div>
} }

<!-- removed items messages -->
@if (removedItems$ | async; as removedItems) { @if (removedItems.length) {
<div class="alert alert-danger" data-testing-id="validation-removed-message">
  {{ 'shopping_cart.adjusted_items.warnung' | translate }}
</div>
}
<ish-basket-validation-products [items]="removedItems" />
}
